<!-- 线上基础客服 -->
<template>
  <div class="" style="width: 99%;">
    <!-- 搜索部分 -->
    <div class="dyh-line-group el-form-class">
      <el-form ref="productForm" :model="search_data" :inline="true" label-width="100px" label-position="right"
        size="medium" style="">
        <!-- <el-form-item label="客服状态：" prop="classify_no">
          <el-select v-model="search_data.class_type" placeholder="请选择客服状态" @change="STypeChange">
            <el-option v-for="item in classTypeOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="客服编号：" prop="agent_no">
          <el-input v-model="search_data.agent_no" placeholder="请输入客服编号"></el-input>
        </el-form-item>
        <el-form-item label="客服昵称：" prop="agent_name">
          <el-input v-model="search_data.agent_name" placeholder="请输入客服名称"></el-input>
        </el-form-item>

      </el-form>
      <el-button type="primary" style="width: 200px;margin-right: 40px;" @click="createAgent">新建客服</el-button>
    </div>
    <!-- 表格部分 -->
    <div class="dyh-body-group" style="height: calc(100% - 100px);">
      <el-table :row-class-name="tableRowClassName" :data="filteredAgentList"
        :header-cell-style="{ background: '#409eff', color: '#fff' }" :height="scroll_height"
        style="width: 100%;margin-bottom: 20px;" row-key="agent_no"
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }">
        <el-table-column label="行号" type="index" align="center" width="80">
        </el-table-column>
        <el-table-column prop="agent_no" align="center" label="客服编号" width="100">
        </el-table-column>
        <el-table-column prop="nick_name" align="center" label="客服昵称" width="100">
        </el-table-column>
        <el-table-column prop="open_id" align="center" label="微信open_id">
        </el-table-column>
        <el-table-column prop="e_mail" align="center" label="客服邮箱" width="200">
        </el-table-column>
        <el-table-column prop="service_order" align="center" label="客服优先级" width="100">
        </el-table-column>
        <el-table-column prop="agent_type" align="center" label="客服状态" width="200">
          <template slot-scope="scope">
            <div class="primary-flex  " style="justify-content: center;align-items: center;">
              <div style="width: 80px;height: 30px;line-height: 30px;text-align: center;border-radius: 4px;"
                :style="scope.row.status === 'True' ? 'background-color: #E1F3D8;color: #67C23A;' : 'background-color: #FFF1F0;color: #FF4D4F;'">
                {{ scope.row.status === 'True' ? '正常' : '未知' }}
              </div>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="agent_type" align="center" label="客服状态" width="200">
          <template slot-scope="scope">
            <div class="primary-flex  " style="justify-content: center;align-items: center;">
              <div style="width: 80px;height: 30px;line-height: 30px;text-align: center;border-radius: 4px;"
                :style="scope.row.status === 'True' ? 'background-color: #E1F3D8;color: #67C23A;' : 'background-color: #FFF1F0;color: #FF4D4F;'">
                {{ scope.row.status === 'True' ? '正常' : '未知' }}
              </div>
            </div>
          </template>
        </el-table-column> -->
        <el-table-column prop="create_time" align="center" label="操作时间" width="220">
          <template slot-scope="scope">
            <data value="">
              <div>创建时间 {{ scope.row.create_time }}</div>
              <div>修改时间 {{ scope.row.create_time }}</div>
            </data>
          </template>
        </el-table-column>
        <el-table-column prop="address" align="center" label="操作">
          <template slot-scope="scope">
            <div class="primary-flex-colum " style="justify-content: center;align-items: center;">
              <el-button type="text" size="mini" @click="updateAgent(scope.row)">修改</el-button>
              <el-button type="text reda-text" size="mini" style="margin: 0px;"
                @click="deleteAgent(scope.row)">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 模态框部分 -->
    <el-dialog :title="dialogTitle" :close-on-click-modal="false" :visible.sync="dialogVisible" width="500px"
      :before-close="handleClose">
      <agentInfo ref="agentInfoRef" @agentDialogCancel="agentDialogCancel"></agentInfo>
    </el-dialog>
    <div class="empty-block"></div>
  </div>
</template>
<script>
//eslint-disable-next-line
import { agentDelete, agentList, agentListOnlineAgenet } from '@/api/onlines/shop.js';
import { showDialog } from '@/js/public';
import agentInfo from "../../components/agentInfo.vue";
export default {
  name: "onlinebaseclassinfo",
  components: {
    agentInfo
  },
  watch: {
    innerWH: {
      handler(newinner, oldinner) {
        if (newinner.innerHeight < 700) {
          this.scroll_height = newinner.innerHeight - 160;
        } else {
          this.scroll_height = newinner.innerHeight - 190;
        }
      },
      deep: true,
      immediate: true
    },
    search_data: {
      handler() {
        this.filterByAgentName();
      },
      deep: true
    }
  },
  computed: {
    innerWH() {
      return this.$store.state.resolution.innerWH;
    }
  },
  data() {
    return {
      view_url: [],
      dialogVisible: false,
      search_data: { //搜索部分
        agent_no: "",
        agent_name: ""
      },
      agentList: [], //分类状态
      agentTypeOptions: [
        { value: 'active', label: '激活' },
        { value: 'inactive', label: '未激活' }
      ],
      filteredAgentList: [],
      scroll_height: "",
      dialogTitle: "新建客服"
    };
  },
  /* eslint-disabled */
  async mounted() {
    this.getAgentList();
  },
  methods: {
    /**
     * 查询客服
     */
    filterByAgentName() {
      if (!this.search_data.agent_name && !this.search_data) {
        // 如果分类名称为空，显示所有分类
        this.filteredAgentList = [...this.agentList];
      } else {
        // 根据分类名称过滤（模糊搜索）
        const searchName = this.search_data.agent_name.trim().toLowerCase();
        const searchNo = this.search_data.agent_no.trim().toLowerCase();
        this.filteredAgentList = this.agentList.filter(item =>
          (item.agent_name && item.agent_name.toLowerCase().includes(searchName)) || (item.agent_no && item.agent_no.toLowerCase().includes(searchNo))
        );
      }
    },
    STypeChange(e) {
      console.log(e);
      if (e === "active") {

      } else {

      }
    },
    /**
     * 排序
     */
    orderByAgentNo() {
      this.filteredAgentList.sort((a, b) => {
        return Number(a.service_order) - Number(b.service_order);
      });
    },
    /**
     * 客服对话框取消事件
     */
    agentDialogCancel(e) {
      console.log("客服对话框取消事件", e);
      if (e.state === true) {
        console.log("客服对话框取消事件e==true", e);
        this.getAgentList();
      }
      this.handleClose();
    },
    /**
     * 新建客服
     */
    createAgent() {
      this.dialogVisible = true;
      this.dialogTitle = "新建客服";
      setTimeout(() => {
        this.$refs.agentInfoRef.handleReset();
      }, 100);
    },
    handleClose() {
      this.dialogVisible = false;
    },
    /**
     * 修改客服
     * @param row 选择的行
     */
    updateAgent(row) {
      const that = this;
      this.dialogTitle = "修改客服";
      this.dialogVisible = true;
      setTimeout(() => {
        that.$refs.agentInfoRef.setFormData(row);
      }, 100);
    },
    /**
     * 删除客服
     * @param row
     */
    async deleteAgent(row) {
      if (await showDialog("删除客服", "确定要删除该客服吗？")) {
        const res = await agentDelete(row.agent_no);
        if (res.state === true) {
          this.successMessage("客服删除成功");
          this.agentList = this.agentList.filter(item => item.agent_no.trim() !== row.agent_no.trim());
          this.filteredAgentList = this.agentList;
        }
      }
    },
    /**
     * 设置行样式
     */
    tableRowClassName({ row, rowIndex }) {
      /* if (rowIndex % 2 === 1) {
        return 'warning-row';
      } */
      return '';
    },
    /**
     * 获取所有客服
     */
    async getAgentList() {
      const res = await agentList();
      this.agentList = res;
      this.filteredAgentList = this.agentList;
      this.orderByAgentNo();
      this.getOnlineAgentList();
    },
    async getOnlineAgentList() {
      const res = await agentListOnlineAgenet();
      console.log("在线客服列表", res);
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .el-table .warning-row {
  background: #ECF5FF !important;
}

.class-table-header {
  background-color: red;
}

.el-form-item {
  margin-bottom: 0px !important;
}

.el-form-class {
  height: 80px;
  justify-content: space-between;
  padding-left: 20px;
}

.class-lf {
  padding-left: 30px;
}

.class-fa {
  width: 100%;
  height: 100%;
  display: flex;
}

.l-title {
  height: 40px;
  font-size: 20px;
  line-height: 2;
  padding: 0 0 10px 20px;
}

.r-body {
  width: calc(100% - 500px);
}

.card-right {
  width: auto;
  max-width: 600px;
  height: auto;
  /* background: rgb(205, 230, 255); */
  padding: 20px;
  margin-left: 20px;
  margin-right: 20px;
}
</style>
